export default __webpack_public_path__ + "static/media/IE.0202015e.svg";